// TODO: доделать
import React from 'react';
import { Redirect } from 'react-router-dom';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import "bootstrap/dist/css/bootstrap.css";
import '../../assets/css/style.css';

import * as api from '../../api/api';

class UserDetailPage extends React.Component {

    constructor(props) {
        super(props);

        this.returnUrl = '/';
        this.userId = localStorage.getItem('imms_id');

        this.state = {
            user: {
                fio: '',
                email: '',
                login: '',
                password: '',
                passwordNew: '',
                passwordNewRepeat: '',
                role: '',
            },
            needRedirect: false,
            wantChangePassword: false,
        }
    }

    async componentDidMount() {
        try {
            this.props.updateLoader({
                loaded: false,
                message: ""
            });

            const user = (await api.makeRequest(api.getUserDetails(this.userId))).data.data;
            const roles = (await api.makeRequest(api.getUserRolesDictionary())).data.data;

            this.setState({
                user: {
                    fio: user.fio,
                    email: user.email,
                    login: user.login,
                    passwordCurrent: '',
                    passwordNew: '',
                    passwordNewRepeat: '',
                    role: roles.find((role) => role.id === user.role_id).name,
                },
            });

            this.props.updateLoader({
                loaded: true
            });

        } catch (err) {
            this.props.updateLoader({
                loaded: true,
                message: "Ошибка получения данных: " + err
            });
        }
    }

    render() {

        if (this.state.needRedirect) {
            return <Redirect to={this.state.returnUrl} />
        }

        return (
            <div>
                <h4 className="mb-4">Профиль пользователя</h4>

                <Formik
                    initialValues={this.state.user}
                    enableReinitialize={true}
                    validate={values => {
                        let errors = {};

                        if (!values.fio) {
                            errors.fio = 'Пожалуйста, заполните это поле';
                        };

                        if (!values.email) {
                            errors.email = 'Пожалуйста, заполните это поле';
                        };

                        if (this.state.wantChangePassword) {
                            if (!values.passwordCurrent) {
                                errors.passwordCurrent = 'Пожалуйста, заполните это поле';
                            };

                            if (!values.passwordNew) {
                                errors.passwordNew = 'Пожалуйста, заполните это поле';
                            };

                            if (!values.passwordNewRepeat) {
                                errors.passwordNewRepeat = 'Пожалуйста, заполните это поле';
                            };

                            if (values.passwordNew !== values.passwordNewRepeat) {
                                errors.passwordNew = 'Введённые пароли не совпадают';
                                errors.passwordNewRepeat = 'Введённые пароли не совпадают';
                            };
                        };

                        return errors;
                    }}
                    onSubmit={async (values, { setSubmitting }) => {
                        try {

                            // console.log(values);
                            this.props.updateLoader({
                                loaded: false,
                                message: ""
                            });

                            const userToSend = {
                                fio: values.fio,
                                email: values.email,
                            };
                            if (this.state.wantChangePassword) {
                                userToSend.passwordCurrent = values.passwordCurrent;
                                userToSend.passwordNew = values.passwordNew;
                            }
                            await api.makeRequest(api.updateUserProfile(this.userId, userToSend));

                            this.props.updateLoader({
                                loaded: true
                            });

                            // this.setState({
                            //     needRedirect: true
                            // });

                            window.location.reload();
                        } catch (err) {
                            this.props.updateLoader({
                                loaded: true,
                                message: 'Ошибка сохранения: ' + err
                            });
                        }
                    }}
                >
                    {({ isSubmitting }) => (
                        <Form className="">
                            <div className="form-group">
                                <label>ФИО</label>
                                <Field className="form-control" type="text" name="fio" />
                            </div>
                            <div className="form-group">
                                <label>E-mail</label>
                                <Field className="form-control" type="email" name="email" />
                                <ErrorMessage className="form-error-message" name="email" component="div" />
                            </div>
                            <div className="form-group">
                                <label>Логин</label>
                                <Field className="form-control" type="text" name="login" disabled />
                            </div>
                            <div className="form-group">
                                <button className="btn btn-secondary" type="button" onClick={() => this.setState({ wantChangePassword: !this.state.wantChangePassword })}>
                                    <FontAwesomeIcon icon="key" size="sm" color="#fff" /> Изменить пароль
                                </button>
                            </div>

                            {
                                this.state.wantChangePassword &&
                                <>
                                    <div className="form-group">
                                        <label>Текущий пароль</label>
                                        <Field className="form-control" type="password" name="passwordCurrent" />
                                        <ErrorMessage className="form-error-message" name="passwordCurrent" component="div" />
                                    </div>
                                    <div className="form-group">
                                        <label>Новый пароль</label>
                                        <Field className="form-control" type="password" name="passwordNew" />
                                        <ErrorMessage className="form-error-message" name="passwordNew" component="div" />
                                    </div>
                                    <div className="form-group">
                                        <label>Повторите новый пароль</label>
                                        <Field className="form-control" type="password" name="passwordNewRepeat" />
                                        <ErrorMessage className="form-error-message" name="passwordNewRepeat" component="div" />
                                    </div>
                                </>
                            }

                            <div className="form-group">
                                <label>Роль</label>
                                <Field className="form-control" type="text" name="role" disabled />
                            </div>

                            <button className="btn btn-primary-custom " type="submit">
                                Сохранить
                            </button>
                        </Form>
                    )}
                </Formik>
            </div>
        );
    }
}

export default UserDetailPage;